export default {
  'checkedout': 'ui-users.data.loanActionMap.checkedOut',
  'checkedin': 'ui-users.data.loanActionMap.checkedIn',
  'declaredLost': 'ui-users.data.loanActionMap.declaredLost',
  'claimedReturned': 'ui-users.data.loanActionMap.claimedReturned',
  'markedMissing': 'ui-users.data.loanActionMap.markedAsMissing',
  'renewed': 'ui-users.data.loanActionMap.renewed',
  'Operator': 'ui-users.data.loanActionMap.source',
  'holdrequested': 'ui-users.data.loanActionMap.holdRequested',
  'recallrequested': 'ui-users.data.loanActionMap.recallRequested',
  'dueDateChanged': 'ui-users.data.loanActionMap.dueDateChanged',
  'renewedThroughOverride': 'ui-users.data.loanActionMap.renewedThroughOverride',
  'checkedOutThroughOverride': 'ui-users.data.loanActionMap.checkedOutThroughOverride',
  'closedLoan': 'ui-users.data.loanActionMap.closedLoan',
  'checkedInReturnedByPatron': 'ui-users.data.loanActionMap.checkedInReturnedByPatron',
  'checkedInFoundByLibrary': 'ui-users.data.loanActionMap.checkedInFoundByLibrary',
  'itemAgedToLost': 'ui-users.data.loanActionMap.itemAgedToLost',
  'patronInfoAdded': 'ui-users.data.loanActionMap.patronInfo',
  'staffInfoAdded': 'ui-users.data.loanActionMap.staffInfo',
  'unknownAction': 'ui-users.data.loanActionMap.unknownAction',
  'reminderFee': 'ui-users.data.loanActionMap.reminderFee',
};
